import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2 } from '@angular/core';
import { BlockNodeEnum } from '@core/enums';

import { Block } from '@core/models/block/block.model';
import { SubmenuService } from '@app/shared/services/submenu.service';

const hasMenu = (item: Block) => item &&
  (
    item.node === BlockNodeEnum.ANCHOR_NODE
    || (
      item.node === BlockNodeEnum.PARAGRAPH_NODE
      && !!item.hrefUrl
    )
  ) &&
  item.children.length > 0;

@Directive({
    selector: '[appSubmenuHover]',
    exportAs: 'submenuHover',
    standalone: false
})
export class SubmenuHoverDirective implements AfterViewInit, OnDestroy {
  @Input('appSubmenuHover') item: Block;

  private mouseover: Function;
  private mouseleave: Function;

  constructor(private _elementRef: ElementRef,
              private _renderer: Renderer2,
              private submenuService: SubmenuService) {
  }

  ngAfterViewInit(): void {
    // has submenu
    if (hasMenu(this.item)) {
      this.mouseover = this._renderer
        .listen(this._elementRef.nativeElement,
          'mouseover',
          this.over.bind(this));

      this.mouseleave = this._renderer
        .listen(this._elementRef.nativeElement,
          'mouseleave',
          this.leave.bind(this));
    }
  }

  over(event) {
    this.submenuService.menuToggle.next({
      mouseEvent: 'mouseover',
      target: event.target,
      menuRect: this._elementRef
        .nativeElement
        .getBoundingClientRect()
    });
  }

  leave(event) {
    this.submenuService.menuToggle.next({
      mouseEvent: 'mouseleave',
      target: event.target,
      menuRect: this._elementRef
        .nativeElement
        .getBoundingClientRect()
    });

  }

  ngOnDestroy(): void {
    if (hasMenu(this.item)) {
      this.mouseover();
      this.mouseleave();
    }
  }
}
